import {z} from 'zod';

import {BaseArticleSchema, BaseVoidResponseSchema, MinMaxQuantitySchema} from '@dms/api/shared';

/**
 * GET
 */
export const GetTransferOrderItemRequestSchema = z.object({
  transferOrderId: z.string(),
  transferOrderItemId: z.string(),
});
export type GetTransferOrderItemRequest = z.infer<typeof GetTransferOrderItemRequestSchema>;

export const GetTransferOrderItemResponseSchema = z.object({
  transferOrderItem: z.object({
    quantity: z.number(),
    serialNumber: z.number().nullish(),
    article: BaseArticleSchema,
    minMaxQuantity: MinMaxQuantitySchema,
  }),
});
export type GetTransferOrderItemResponse = z.infer<typeof GetTransferOrderItemResponseSchema>;

/**
 * POST
 */
export const PostTransferOrderItemRequestSchema = z.object({
  transferOrderId: z.string(),
  body: z.object({
    articleId: z.string(),
  }),
});
export type PostTransferOrderItemRequest = z.infer<typeof PostTransferOrderItemRequestSchema>;

export const PostTransferOrderItemResponseSchema = z.object({
  transferOrderItemId: z.string(),
});
export type PostTransferOrderItemResponse = z.infer<typeof PostTransferOrderItemResponseSchema>;

/**
 * PATCH
 */
export const PatchTransferOrderItemRequestSchema = z.object({
  transferOrderId: z.string(),
  transferOrderItemId: z.string(),
  body: z.object({
    quantity: z.number(),
  }),
});
export type PatchTransferOrderItemRequest = z.infer<typeof PatchTransferOrderItemRequestSchema>;

export const PatchTransferOrderItemResponseSchema = z.object({
  transferOrderItemId: z.string(),
  quantity: z.number(),
  article: BaseArticleSchema,
});
export type PatchTransferOrderItemResponse = z.infer<typeof PatchTransferOrderItemResponseSchema>;

/**
 * DELETE
 */
export const DeleteTransferOrderItemRequestSchema = z.object({
  transferOrderId: z.string(),
  body: z.object({
    transferOrderItemIds: z.array(z.string()),
  }),
});
export type DeleteTransferOrderItemRequest = z.infer<typeof DeleteTransferOrderItemRequestSchema>;

export const DeleteTransferOrderItemResponseSchema = BaseVoidResponseSchema;
export type DeleteTransferOrderItemResponse = z.infer<typeof DeleteTransferOrderItemResponseSchema>;
